<template>
  <div class="p-4">
    <page-header
      :page="page"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    >
      <template v-slot:customActions>
        <action-button
          i="fas fa-arrow-circle-left"
          variant="outline-success mx-2"
          :responsive="false"
          @click="goBack"
        >
          Regresar
        </action-button>
        <action-button
          v-if="!isSubmitted"
          i="fas fa-save"
          variant="success mx-2"
          :responsive="false"
          @click="onSave"
        >
          Someter
        </action-button>
        <action-button
          id="dropdownMenuButtonPrint"
          v-if="isSubmitted"
          i="fas fa-print"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          variant="success mx-2 dropdown-toggle"
          :responsive="false"
        >
          Imprimir
        </action-button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonPrint">
          <div
            v-if="canDownloadSaee05"
            class="dropdown-item btn"
            @click="printSaee05(item)"
          >
            <i class="fas fa-file-download text-green" />
            <span class="pl-2">SAEE-05</span>
          </div>
          <div
            v-if="canDownloadSaee03c"
            class="dropdown-item btn"
            @click="printSaee03"
          >
            <i class="fas fa-file-download text-green" />
            <span class="pl-2">SAEE-03c</span>
          </div>
        </div>
      </template>
    </page-header>
    <div class="row">
      <div class="col-12">
        <Board v-if="studentDetails" :details="studentDetails" />
      </div>
      <GeneralInformation
        ref="generalInfo"
        :is-submitted="isSubmitted"
        @change-academic-year="onChangeAcademicYear($event)"
        @change-comment="onChangeComment($event)"
        @change-evaluation-date="onChangeEvaluationDate($event)"
      />
      <br />
      <EvaluationInformation
        ref="evaluationInfo"
        :key="evaluationInfoKey"
        :student-sie="studentSie"
        :committee-id="committeeId"
        :validate="validateDiscussion"
        :show-error="validateComponent"
        :is-submitted="isSubmitted"
        :collections="collections"
        :persisted-evaluations="
          evaluationInformationLayout.evaluationInformationData
        "
        @on-show-elegibility-determination="
          onShowEligibilityDeterminationChange
        "
        @add-evaluation="onAddEvaluationHandler"
        @remove-evaluation="onRemoveEvaluationHandler"
        @on-get-evaluations="onGetEvaluationsHandler"
        @add-evaluation-layout="onEvaluationLayout"
        @on-evaluation-history-add="persistCurrentInformation($event)"
      />
      <div
        v-if="serverEvaluationErrorMessage != null"
        class="row d-flex justify-content-start mt-2"
      >
        <div class="d-flex">
          <div class="col-md-12 col-sm-12 p-3 ml-1">
            <ErrorComponent
              v-if="serverEvaluationErrorMessage != null"
              variant="no-border error-margin-left mb-2 custom-errors-list"
              :message="serverEvaluationErrorMessage"
            />
          </div>
        </div>
      </div>

      <div
        v-show="showElegibilityDetermination"
        class="col-12 mt-3"
        style="padding-left: 0px"
      >
        <ValidationObserver ref="eligibilityDetermination">
          <EligibilityDeterminationTriannual
            v-model="eligibilityDeterminationDataTriannual"
            ref="triannualEvaluation"
            :called-from="'Triannual'"
            :date-registration="model.registrationDate"
            :show-intervention-questionnaire="false"
            :determination-options="determinationElegibilityOptions"
            :disabled="isSubmitted"
            has-validation-pending
          />
        </ValidationObserver>
      </div>

      <!-- Documentos de Respaldo de la Discusión -->
      <div class="col-12 mt-3">
        <SectionTitle
          has-line
          content="Documentos de Respaldo de la Discusión"
        /> 
      </div>

      <div class="col-12">
        <EvaluationDocuments
          ref="evaluationDocuments"
          :evaluation-date="generalEligibilityDetermination.academicyearfordate"
          :student-sie-id="Number(studentSie)"
          :is-submitted="isSubmitted"
          :evaluations="evaluationsForDocuments"
          :current-documents="currentEvaluationDocuments"
          :evaluations-without-documents="evaluationsWithoutDocuments"
          :non-recommended-without-documents="nonRecommendedWithoutDocuments"
          :show-error="validateComponent"
          @on-add-document="onAddEvaluationDocument"
          @on-edit-document="onEditEvaluationDocument"
          @on-remove-document="onRemoveEvaluationDocument"
        />
      </div>
      <!-- Documentos de Respaldo al Proceso de Determinacion -->
      <div v-if="canShowCriterial2" class="col-12">
        <SectionTitle
          has-line
          content="Criterio 2: Documentos de Respaldo para Dificultad Académica"
        />
        <BackupDocument
          :studentSieIdProp="Number(studentSie)"
          :documents="existingDocuments"
          :show="$route.params.evaluationDateId"
          :disabled="isSubmitted"
          @files="gettingBackupDocument"
          @file-not-found="fileNotFound"
        />
      </div>
      <!-- Firma de Participantes -->
      <div class="col-12 mt-4">
        <SectionTitle has-line content="Firma de Participantes" />
      </div>

      <div class="col-12">
        <Tab9ParticipantSignatures
          ref="participantSignatures"
          :key="componentKey"
          :value="signatureList"
          :options="availableSignatureOptions"
          :is-draft="!isSubmitted"
          :participation-types="participationTypeList"
          :alternate-participations="alternateParticipationTypeList"
          @addSignature="addSignature()"
          @deleteSignature="deleteSignature"
        />
      </div>
      <div class="col-12">
        <ValidationObserver ref="termsResponsability">
          <!-- Certificación de procedimientos -->
          <div class="mt-5">
            <div class="mt-3 tag-badge pl-2">
              <span class="dot text-center">
                <i
                  class="far fa-check-circle orange-icon orange-icon-badge-align"
                />
              </span>
              <span class="tag-badge-title py-1 pl-2">
                Certificación de procedimientos
              </span>
            </div>
          </div>
          <div class="row mx-1">
            <div class="col-12 px-1">
              <div class="border-box">
                Certifico por este medio, que este referido podrá encontrarse en
                el expediente físico del estudiante firmado por todas las partes
                involucradas. (0502)
              </div>
            </div>
            <div class="col-12 px-0">
              <ValidationProvider
                v-slot="{ errors }"
                name="checkboxConditions"
                rules="required"
              >
                <div class="row mx-1">
                  <div
                    class="border-box gray"
                    :class="{ error: errors.length > 0 }"
                  >
                    <div class="col-12 px-0 py-0">
                      <div class="custom-control custom-checkbox">
                        <div class="custom-control custom-checkbox">
                          <input
                            id="checkboxConditions"
                            v-model="termsAccepted"
                            v-validate="'required'"
                            :disabled="isSubmitted"
                            type="checkbox"
                            class="custom-control-input"
                            name="checkboxConditions"
                          />
                          <label
                            class="custom-control-label pl-3"
                            for="checkboxConditions"
                          >
                            Acepto
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="errors.length > 0" class="row mt-1">
                    <div class="col-12">
                      <i class="fa fa-times-circle text-red pr-2" />
                      <span class="invalid">
                        Favor certificar los términos y responsabilidades
                      </span>
                    </div>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>
<script>
import { SectionTitle } from '@/components/pei/shared';
import PageHeader from 'PageHeader';
import alertMixin from '@/mixin/alert.mixin';
import studentApi from '@/services/student.js';
import storeMixin from '@/mixin/storeGenerator';
import Board from 'Board';
import { GeneralInformation, EvaluationInformation } from './components';
import Tab9ParticipantSignatures from '@/components/pei/tabs/components/Tab9/participantSignatures/Tab9ParticipantSignatures';
import signatureService from '@/modules/common/signature.api';
import EligibilityDeterminationTriannual from '@/components/triannualDeterminationProcess/components/EligibilityDeterminationV2';
import EvaluationDocuments from './components/EvaluationDocuments.vue';
import objectToFormData from 'object-to-formdata';
import resourcesService from '@/services/resources.js';
import placementCommitteeCategory from '@/utils/constants/student/placementCommitteeCategory';
import DiscussionStatus from '@/utils/constants/student/discussionStatus';
import ErrorComponent from '@/components/common/Error';
import userRoles from '@/utils/constants/userRoles';
import documentTypes from '@/utils/constants/documentTypes';
import reportService from '@/services/report';
import { getEvaluationDiscussionStatus } from '@/modules/common/code.api.js';
import studentEvaluationService from '@/modules/student-evaluations/api.js';
import impedimentTypeNames from '@/utils/constants/reg/impedimentsType';
import ReevaluationPeriod from '@/utils/constants/reevaluationPeriod.js';
import studentTrianualService from '@/modules/student-trianual/api.js';
import generalService from '@/services/pei/general';
import BackupDocument from '@/components/studentEvaluation/BackupDocument';
import ActionButton from 'ActionButton';
import DisciplineTypes from '@/utils/constants/disciplineTypes';
import { discussionStatuses } from '@/utils/constants/evaluation-discussion/discussionStatusCode';

const LOCAL_STORAGE_KEY = 'evaluation-discussion-data';

const DOCUMENT_TYPES = {
  MINUTA: 66,
  OTROS: 67,
};

const EVALUATION_DATE_TYPES = {
  existingEvaluationAnalysis: 312,
  triannualReview: 313,
};

export default {
  name: 'MainEvaluationDiscussion',
  components: {
    PageHeader,
    Board,
    SectionTitle,
    GeneralInformation,
    EvaluationInformation,
    Tab9ParticipantSignatures,
    EligibilityDeterminationTriannual,
    EvaluationDocuments,
    BackupDocument,
    ActionButton,
    ErrorComponent,
  },
  mixins: [storeMixin, alertMixin],
  data: () => ({
    page: {
      icon: 'fas fa-user-circle',
      title: 'Proceso de Discusión de Evaluación en COMPU',
      routes: [
        'Inicio',
        'Estudiante',
        'Proceso de Discusión de Evaluación en COMPU',
      ],
    },
    canDownloadSaee05: false,
    canDownloadSaee03c: false,
    canShowCriterial2: false,
    showElegibilityDetermination: false,
    //signature Managment properties
    signatureCounter: 0,
    signatureList: [],
    // Validar propiedades fuera de VeeValidate.
    validateComponent: false,
    componentKey: 0,
    availableSignatureOptions: [],
    participationTypeList: [],
    alternateParticipationTypeList: [],
    student: null,
    model: {},
    backupDocumentsData: {
      files: [],
      types: [],
    },
    eligibilityDeterminationDataTriannual: {
      impedimentsOptions: [],
      dateEligibility: null, // type: [Date, String],
      isElegibility: null,
      dissabilityOption: null, //int
      comments: '', //String
      meetingQty: null, //Object
      isHealthSpecialistNecessary: null, //Bool
      isConditionsInProcessNecessary: null, //Bool
      participatedSpecialist: null, //Bool
      certification: null,
      impediment: null,
      severity: null,
      disorders: null,
      partialHearing: null,
      //Multiple
      impedimentMultiple: {
        impediment: null,
        selectedItems: [],
      }, //Object
      severityMultiple: null,
      disordersMultiple: null, //Object
      partialHearingMultiple: null, //Object
      eligibilityDeterminationConditions: {
        condition: null,
        selectedItems: [],
      },
    },
    //General Determination Information Section I
    generalEligibilityDetermination: {
      changeImpediment: false,
      academicYearId: null,
      academicyearfordate: null,
      academicYearDesc: null,
    },
    validateDiscussion: true,
    evaluations: [],
    currentDocuments: [],
    currentEvaluations: [],
    evaluationDocuments: [],
    evaluationInformationLayout: {
      evaluationInformationData: [],
    },
    serverEvaluationErrorMessage: null,
    resources: [],
    evaluationDescription: null,
    evaluationDateTypeCode: EVALUATION_DATE_TYPES.triannualReview,
    placementCommitteeCategoryId:
      placementCommitteeCategory.EvaluacionAdicional,
    hasRejectedEvaluations: false,
    hasValidDocsForRejections: false,
    hasValidDocsForNonRecommended: false,
    isSubmitted: false,
    collections: {
      discussionStatuses: [],
    },
    termsAccepted: null,
    evaluationInfoKey: 0,
    determinationElegibilityOptionsOriginal: [],
    determinationElegibilityOptions: {
      impediments: [],
      notImpediments: [],
      severities: [],
      disorders: [],
      multipleImpediments: [],
      conditions: [],
    },
    evaluationDateId: null,
    existingDocuments: {},
    evaluationsWithoutDocuments: [],
    hasCriterial2Error: null,
  }),
  computed: {
    showSaee05Printable() {
      if (this.evaluations.length > 0) {
        return this.evaluations.some((x) => x?.determines === true);
      }
      return this.getEvaluations.some((x) => x?.isDetermination);
    },
    hasNonDeterminesEvaluation() {
      if (this.evaluations.length > 0) {
        return this.evaluations.some(
          (x) =>
            x?.determines === false ||
            x?.discussionStatusId === DiscussionStatus.Rejected ||
            x?.disciplineTypeId === DisciplineTypes.Ocupacional
        );
      }

      return this.getEvaluations.some(
        (x) =>
          x?.isDetermination === false ||
          x?.discussionStatusId === DiscussionStatus.Rejected
      );
    },
    studentDetails() {
      if (!this.student) return;
      return [
        [
          {
            label: 'Estudiante',
            cols: 'col-md-3 col-sm-12',
            data: this.student.fullName,
            icon: 'fas fa-address-book',
          },
          {
            label: 'Número SIE',
            cols: 'col-md-3 col-sm-12',
            data: this.student.studentId,
            icon: 'fas fa-clipboard-list-check',
          },

          {
            label: 'Escuela',
            cols: 'col-md-3 col-sm-12',
            data: `${this.student.schoolCode} - ${this.student.schoolName}`,
            icon: 'fas fa-clipboard-list-check',
          },
          {
            label: 'Impedimento',
            cols: 'col-md-3 col-sm-12',
            data: this.student.impediment,
            icon: 'fas fa-clipboard-list-check',
          },
        ],
      ];
    },
    studentSie() {
      return this.$route.params.studentSIE;
    },
    committeeId() {
      return this.$route.params?.placementCommitteeId
        ? String(this.$route.params.placementCommitteeId)
        : '';
    },
    evaluationsForDocuments() {
      const evaluations = [...this.currentEvaluations];
      return evaluations;
    },
    currentEvaluationDocuments() {
      const documents = [...this.currentDocuments];
      return documents;
    },
    nonRecommendedWithoutDocuments() {
      const withoutDocument = [];

      let filteredNonRecommended = this.evaluationInformationLayout.evaluationInformationData.filter(
        (x) =>
          x.validForRecommendation && !x.recommended && x.timeToExpiration <= 90
      );

      if (filteredNonRecommended.length > 0) {
        const evaluationDocument = this.currentDocuments.find(
          (x) => x.documentType.id == DOCUMENT_TYPES.MINUTA
        );

        if (evaluationDocument) {
          const { evaluations } = evaluationDocument;

          filteredNonRecommended.forEach((x) => {
            const exists = evaluations.find(
              (e) => e.id == x.studentEvaluationId
            );

            if (!exists) {
              withoutDocument.push(
                `${x.evaluationDate} - ${x.disciplineTypeName}`
              );
            }
          });
        } else {
          filteredNonRecommended.forEach((x) => {
            withoutDocument.push(
              `${x.evaluationDate} - ${x.disciplineTypeName}`
            );
          });
        }
      }

      return withoutDocument;
    },
    isUserPilotPlan() {
      return this.$store.getters['$_user/pilotPlan'];
    },
    getEvaluations() {
      const evaluations = this.$refs?.evaluationInfo
        ?.evaluationInformationLayout?.evaluationInformationData;
      return evaluations ?? [];
    },
  },
  watch: {
    'eligibilityDeterminationDataTriannual.participatedSpecialist'(value) {
      if (value == true) {
        this.addSpecialistSignature();
      } else {
        this.removeSpecialistSignature();
      }
    },
    'eligibilityDeterminationDataTriannual.isElegibility'(value) {
      this.additionalQuestionsFlag =
        this.$refs.generalInfo.value.academicYearId != null &&
        this.eligibilityDeterminationDataTriannual != null &&
        this.eligibilityDeterminationDataTriannual.eligibilityFlag == '0';
    },
    termsAccepted(value) {
      if (!value) {
        //only if is false = null for validate trigged, yes i know i can use required_if (but when make this refactory doesnt work)
        this.termsAccepted = null;
      }
    },
  },
  async mounted() {
    //Load all Signatures
    await Promise.all([
      this.getParticipationTypeList(),
      this.getAlternateParticipationTypeList(),
      this.setSignatureConfig(),
      this.getImpedimentOptions(),
      this.getConditionsCatalog(),
    ]);
    // then get the data for read-only
    if (this.committeeId > 0) {
      this.isSubmitted = true; // read only mode.
      this.termsAccepted = true; //
      const {
        data: response,
      } = await studentEvaluationService.getEvaluationByCommetteeId(
        this.committeeId
      );

      if (response && response.length) {
        this.placementCommitteeId = this.committeeId;
        this.evaluationDateId = response[0].evaluationDateId;
        this.setReadOnlyData(response);
      }
    } else {
      // Fetch collections
      await this.loadDiscussionStatuses();

      this.resources = await resourcesService.LoadValidationMessages([
        '17306',
        '22124',
        '150',
        'R90006',
        '22144',
        '22145',
        '22147',
        '1908031',
      ]);

      if (localStorage.getItem(LOCAL_STORAGE_KEY)) {
        await this.$nextTick(async () => {
          await this.setPersistedInformation();
          await this.forceRerender();
        });
      }
    }
    this.canDownloadSaee05 = this.showSaee05Printable;
    this.canDownloadSaee03c = this.hasNonDeterminesEvaluation;
  },
  methods: {
    async forceRerender() {
      this.evaluationInfoKey += 1;
    },
    goBack() {
      this.$router.go(-1);
    },
    onAddEvaluationHandler(item) {
      if (Array.isArray(item)) {
        this.evaluations = this.evaluations.concat(item);
      } else {
        this.evaluations.push(item);
      }
    },
    onShowEligibilityDeterminationChange(show) {
      this.showElegibilityDetermination = show;

      const triannualRef = this.$refs.triannualEvaluation;

      // if it hides determination information's section then clear the section's info.
      if (!show) {
        triannualRef.radioHealthSpecialistNecessaryChange();

        const refTriannualEvaluationFields = triannualRef.field;
        const fieldsToReset = Object.keys(refTriannualEvaluationFields);
        fieldsToReset.forEach((property) => {
          const field = refTriannualEvaluationFields[property];
          // if it isn't a field but a value directly, then continue with next interation
          if (!Object.keys(field).length) return;
          // if field has model prop then reset it
          if (Object.keys(field).filter((prop) => prop === 'model').length)
            field.model = null;
        });
      }

      this.checkIfCanShowCriterials();
    },
    checkIfCanShowCriterials() {
      const isAnyEvaDetermining = this.isAnyEvaluationDetermining();
      this.canShowCriterial2 = isAnyEvaDetermining; // shows only if doesn't have any evaluation's determination marked as yes.
    },
    onRemoveEvaluationHandler(item) {
      const index = this.evaluations.findIndex(
        (x) => x.studentEvaluationId === item.studentEvaluationId
      );
      this.evaluations.splice(index, 1);
      this.$forceUpdate();
      this.checkIfCanShowCriterials();
    },
    async getStudent(sie) {
      const { data } = await studentApi.getBySie(sie);
      this.student = data;
    },
    onEvaluationLayout(item) {
      this.evaluationInformationLayout = item;
    },
    onChangeAcademicYear(academicYear) {
      this.generalEligibilityDetermination.academicYearId = academicYear.id;
      this.generalEligibilityDetermination.academicYearDesc =
        academicYear.description;
    },
    onChangeComment(comment) {
      this.evaluationDescription = comment;
    },
    onChangeEvaluationDate(evaluationDate) {
      this.generalEligibilityDetermination.academicyearfordate = evaluationDate;
      this.eligibilityDeterminationDataTriannual.dateEligibility = evaluationDate;
    },
    async onSave() {
      this.refreshEvaluationsWithoutDocuments();
      this.serverEvaluationErrorMessage = null;
      this.validateRejectedEvaluations();
      this.validateNonRecommendedEvaluations();

      this.validateComponent = true;

      this.signatureList.map((x) => (x.isRequired = this.validateComponent));

      let isValidGeneralInfo = await this.$refs.generalInfo.$refs.generalInformationForm.validate();
      let isValidEvalForm = await this.$refs.evaluationInfo.$refs.evaluationInformationForm.validate();

      let isValidTriannualEvaluation = true;

      let isValidSignature = await this.$refs.participantSignatures.$refs.observer.validate();

      let isValidTermsConditions = await this.$refs.termsResponsability?.validate();
      let isValidEvaluationDocuments = this.$refs.evaluationDocuments?.validDocumentDates();

      await this.$refs.evaluationInfo.validateEvaluation();

      let filteredEligibilityFlag = this.evaluationInformationLayout.evaluationInformationData.filter(
        (x) => x.isImpedimentEvaluationFlag
      );

      if (filteredEligibilityFlag.length > 0) {
        isValidTriannualEvaluation =
          this.$refs.eligibilityDetermination &&
          this.$refs.triannualEvaluation &&
          this.$refs.triannualEvaluation.validateImpediments() &&
          this.$refs.eligibilityDetermination.validate(); //Section X
      }

      this.validateDiscussion =
        this.evaluationInformationLayout.evaluationInformationData.length > 0;

      let hasInvalidEvaluations =
        this.evaluationInformationLayout.evaluationInformationData.filter(
          (x) => x.isValid == false
        ).lenght > 0;

      let isValidDiscussion = this.validateDiscussion;

      const selectedEvaluations = this.getSelectedEvaluations();
      let filtered = this.evaluationInformationLayout.evaluationInformationData.filter(
        (x) =>
          x.discussionStatusId == DiscussionStatus.Rejected &&
          selectedEvaluations?.some((s) => s.id === x.studentEvaluationId)
      );

      let filteredNonRecommended = this.evaluationInformationLayout.evaluationInformationData.filter(
        (x) =>
          x.validForRecommendation &&
          !x.recommended &&
          x.reevaluationPeriodId == ReevaluationPeriod.Months &&
          x.reevaluationTime <= 6
      );

      let filteredDocs = this.currentEvaluationDocuments.filter(
        (x) => x.documentType.id == documentTypes.EvaluationDiscussionMinute
      );

      this.hasRejectedEvaluations = filtered.length > 0;
      this.hasNonRecommendedEvaluations = filteredNonRecommended.length > 0;
      this.hasValidDocsForRejections = filteredDocs.length > 0;
      this.hasValidDocsForNonRecommended = filteredDocs.length > 0;

      filtered.forEach((x) => {
        var documentFound = false;
        filteredDocs.forEach((z) => {
          if (
            z.evaluations.filter(
              (evaluation) => evaluation.id == x.studentEvaluationId
            ).length > 0
          ) {
            documentFound = true;
          }
        });
        this.hasValidDocsForRejections =
          this.hasValidDocsForRejections && documentFound;
      });
      filteredNonRecommended.forEach((x) => {
        var documentFound = false;
        filteredDocs.forEach((z) => {
          if (
            z.evaluations.filter(
              (evaluation) => evaluation.id == x.studentEvaluationId
            ).length > 0
          ) {
            documentFound = true;
          }
        });
        this.hasValidDocsForNonRecommended =
          this.hasValidDocsForNonRecommended && documentFound;
      });

      const isValidImpediments = this.$refs.triannualEvaluation.validateImpediments();
      const hasRejectedEvaluationsWithoutDocuments =
        this.evaluationsWithoutDocuments.length > 0;
      const hasNotRecommendedWithoutDocuments =
        this.nonRecommendedWithoutDocuments?.length == 0;

      if (
        this.hasCriterial2Error ||
        !isValidImpediments ||
        !isValidGeneralInfo ||
        !isValidEvalForm ||
        !isValidTriannualEvaluation ||
        !isValidSignature ||
        !isValidTermsConditions ||
        !isValidDiscussion ||
        hasRejectedEvaluationsWithoutDocuments ||
        hasInvalidEvaluations ||
        !hasNotRecommendedWithoutDocuments ||
        (this.hasRejectedEvaluations && !this.hasValidDocsForRejections) ||
        (this.hasNonRecommendedEvaluations &&
          !this.hasValidDocsForNonRecommended) ||
        !isValidEvaluationDocuments
      ) {
        this.ShowToast(
          'Alerta',
          'Favor de completar la información requerida.',
          'error'
        );
        return;
      } else {
        this.validateComponent = false;
        await this.send();
      }
    },
    async send() {
      const elegibilityInfo = {
        eligibilityEvaluationInfo: this.evaluationInformationLayout
          .evaluationInformationData,
        attendanceInfo: this.getSignatureList(),
        ...this.eligibilityDeterminationDataTriannual,
      };

      this.validateEligibility(elegibilityInfo, async (status) => {
        if (!status) {
          this.ShowToast(
            'Información Incompleta',
            'Favor verificar y completar la información solicitada.',
            'error'
          );
          return;
        }
        // JSF: US92489 - If the student is not eligible, the user must confirm that the student will be changed to Egreso status.
        const hasEvaluationsRejected = (
          elegibilityInfo.eligibilityEvaluationInfo ?? []
        ).some((x) => x.discussionStatusId === discussionStatuses.rejected);
        const isNotEligible =
          this.eligibilityDeterminationDataTriannual.isElegibility === false;
        let isEgresoConfirmed = false;
        if (isNotEligible && hasEvaluationsRejected) {
          isEgresoConfirmed = await this.ShowCancelModal(
            'Confirmación',
            `<div class="mb-3"> Al continuar con esta acción, el estudiante cambiará a estatus Egreso. Esto dejará sin efecto lo siguiente:</div>
              <ul>
                <li class="mb-2"> Cancelará los referidos activos de evaluaciones </li>
                <li class="mb-2"> Cancelará los referidos de terapia cambiaran a estatus No Vigente: Egreso </li>
                <li class="mb-2"> Los proveedores de servicios no podrán facturas servicios a partir de esta fecha. </li>
                <li class="mb-2"> Cancelará la elegibilidad para las solicitudes de transportación escolar. </li>  
              </ul>
            `,
            'Si',
            'No'
          );

          if (!isEgresoConfirmed) return;
        }

        try {
          let data = this.getDataAsJson();

          let res = await this.$ApiPost('/api/studentEvaluation/v2/save', data);

          this.save = true;
          this.isEnabled = false;
          this.isSubmitted = true;
          this.evaluationDateId = res.data.evaluationDateId;
          this.placementCommitteeId =
            res.data.placementCommittee.placementCommitteId;

          if (isEgresoConfirmed) {
            this.ShowToast(
              'Proceso exitoso',
              'Su información ha sido guardada',
              'success'
            );
            return;
          }

          if (
            this.isUserPilotPlan &&
            (this.userRole == userRoles.maestro ||
              this.userRole == userRoles.director) &&
            this.evaluationInformationLayout.evaluationInformationData.filter(
              (x) => x.reevaluationRequired && x.recommended
            ).length > 0
          ) {
            this.$router.push({
              name: 'evaluations-appointment',
              params: {
                studentSieId: this.student.studentId,
                from: 'evaluationDiscuss',
              },
            });
          }

          if (!this.hasRejectedEvaluations) {
            this.ShowToast(
              'Proceso exitoso',
              'Su información ha sido guardada',
              'success'
            );

            this.canDownloadSaee05 = this.showSaee05Printable;
            this.canDownloadSaee03c = this.hasNonDeterminesEvaluation;
            return;
          }

          let isRedirectNeeded = await this.ShowCancelModal(
            'Confirmación',
            '¿Desea generar un referido de evaluación independiente a través del mecanismo de remedio provisional?',
            'Si',
            'No'
          );

          if (!isRedirectNeeded) {
            this.canDownloadSaee05 = this.showSaee05Printable;
            this.canDownloadSaee03c = this.hasNonDeterminesEvaluation;
            return;
          }

          const rejectedEvaluationIds = this.evaluationInformationLayout.evaluationInformationData
            .filter((x) => x.discussionStatusId == DiscussionStatus.Rejected)
            .map((x) => x.studentEvaluationId);

          this.$router.push({
            name: `MainCreateRpRequest`,
            params: { StudentSieId: this.$route.params.studentSIE },
            query: { RejectedEvaluationIds: rejectedEvaluationIds },
          });
        } catch (err) {
          this.incompleteInformation();
          // Some of the error messages must be displayed in a specific section
          this.handleEvaluationsAndElegibilityErrorResponse(
            err?.response?.data
          );
        }

        this.throwSave = false;
        this.validate = false;
      });
    },
    async incompleteInformation() {
      this.ShowToast('Alerta', this.resources[1908031], 'error');
    },
    async validateEligibility(evalAndEligibilityInfo, callback) {
      let self = this;
      const changeImpediment = this.generalEligibilityDetermination
        .changeImpediment;
      let evaluationSectionIsValid = true;
      this.serverEvaluationErrorMessage = null;

      if (changeImpediment === true) {
        const validationResult = await this.$ApiPost(
          `api/studentregistry/v2/validate/${this.student.studentId}/evaluationsandeligibility`,
          evalAndEligibilityInfo || {}
        ).catch((err) => {
          evaluationSectionIsValid = false;
          self.handleEvaluationsAndElegibilityErrorResponse(
            err?.response?.data
          );
          callback(false);
        });
        if (validationResult) {
          if (evaluationSectionIsValid) {
            callback(true);
          }
        } else {
          callback(false);
        }
      } else {
        callback(true);
      }
    },
    gettingBackupDocument(data) {
      this.backupDocumentsData = data;
    },
    handleEvaluationsAndElegibilityErrorResponse(response) {
      switch (response.code) {
        case '22148':
        case '22149':
        case '22150':
        case '22146':
        case '22147':
          this.serverEvaluationErrorMessage = response.message;
          break;
        default:
          // The toastr must be always displaying 'incomplete data' even if this method is not executed.
          break;
      }
    },
    fileNotFound(data) {
      this.hasCriterial2Error = data.error;
    },
    getDataAsJson() {
      let filteredEligibilityFlag = this.evaluationInformationLayout.evaluationInformationData.filter(
        (x) => x.isImpedimentEvaluationFlag
      );

      const selectedEvaluations = this.getSelectedEvaluations();
      // only send the selected evaluations ( and avoid sending the evaluations that are not shown in the evaluation section )
      const eligibilityEvaluationInfo = this.evaluationInformationLayout.evaluationInformationData?.filter(
        (x) => selectedEvaluations.some((y) => y.id === x.studentEvaluationId)
      );
      const reevaluation = this.evaluationInformationLayout.evaluationInformationData.filter(
        (x) =>
          x.validForRecommendation &&
          // if x.recommended has a boolean value, not matter if true or false
          typeof x.recommended === 'boolean'
      );
      eligibilityEvaluationInfo.push();
      let data = {
        studentSieid: this.studentSie,
        academicYearId: this.generalEligibilityDetermination.academicYearId,
        academicYearDesc: this.generalEligibilityDetermination.academicYearDesc,
        evaluationDate: this.generalEligibilityDetermination
          .academicyearfordate,
        evaluationDateTypeCode: this.evaluationDateTypeCode,
        commentDescription: this.evaluationDescription,
        impedimentChangeFlag: this.generalEligibilityDetermination
          .changeImpediment,
        isSufficientFlag: filteredEligibilityFlag.length > 0 ? '1' : '0',
        hasEligibilityFlag: filteredEligibilityFlag.length > 0 ? true : false,
        elegibilityInfo: {
          impedimentsOptions: this.eligibilityDeterminationDataTriannual
            .impedimentsOptions,
          //Section V (Determination Elegibility)
          eligibilityDeterminationDate: this
            .eligibilityDeterminationDataTriannual.dateEligibility,

          eligibilityFlag: this.eligibilityDeterminationDataTriannual
            .isElegibility
            ? '1'
            : '0',
          impedimentId: this.eligibilityDeterminationDataTriannual.impediment
            ?.id,
          impedimentSeverityCode: this.eligibilityDeterminationDataTriannual
            .severity?.id,
          impedimentAutismCode: this.eligibilityDeterminationDataTriannual
            .disorders?.id,
          impedimentPartialHearingFlag: this
            .eligibilityDeterminationDataTriannual.partialHearing
            ? '1'
            : '0',
          dissabilityOption:
            this.eligibilityDeterminationDataTriannual.dissabilityOption == null
              ? null
              : this.eligibilityDeterminationDataTriannual.dissabilityOption,
          eligibilityComment: this.eligibilityDeterminationDataTriannual
            .comments,
          healthSpecialistParticipationFlag: this
            .eligibilityDeterminationDataTriannual.isHealthSpecialistNecessary
            ? '1'
            : '0',
          healthSpecialistParticipatedFlag: this
            .eligibilityDeterminationDataTriannual.participatedSpecialist
            ? '1'
            : '0',
          postEligibilityMeetingsQty: this.eligibilityDeterminationDataTriannual
            .meetingQty?.id,
          multipleImpedimentInfo: this.eligibilityDeterminationDataTriannual.impedimentMultiple.selectedItems.map(
            (item) => {
              let impedimentItem = {
                impedimentId: item.id,
                severityId:
                  item.title === impedimentTypeNames.MR_DiscapacidadIntelectual
                    ? item.association
                    : null,
                autismId:
                  item.title === impedimentTypeNames.AUT_Autismo
                    ? item.association
                    : null,
                partialHearingFlag:
                  item.title === impedimentTypeNames.HI_ProblemaAudicion
                    ? item.association == 'true'
                      ? '1'
                      : '0'
                    : null,
                name:
                  item.title ===
                    impedimentTypeNames.MR_DiscapacidadIntelectual ||
                  item.title === impedimentTypeNames.AUT_Autismo ||
                  item.title === impedimentTypeNames.HI_ProblemaAudicion
                    ? item.title
                    : item.name,
              };
              return impedimentItem;
            }
          ),
          eligibilityEvaluationInfo: [
            ...eligibilityEvaluationInfo,
            ...reevaluation,
          ],
          attendanceInfo: this.getSignatureList(),
          documentAttachmentInfo: this.currentEvaluationDocuments,
          backupDocumentsData: [],
          conditionsInProcessNecessaryFlag:
            this.eligibilityDeterminationDataTriannual
              .isConditionsInProcessNecessary == null
              ? false
              : this.eligibilityDeterminationDataTriannual
                  .isConditionsInProcessNecessary,
          eligibilityDeterminationConditions: this.eligibilityDeterminationDataTriannual.eligibilityDeterminationConditions.selectedItems.map(
            (c) => c.id
          ),
        },
        placementCommittee: {
          committeeDate: this.generalEligibilityDetermination
            .academicyearfordate,
          academicYearId: this.generalEligibilityDetermination.academicYearId,
          committeeDescription: this.evaluationDescription,
          placementCommitteeCategoryId: this.placementCommitteeCategoryId,
          impedimentChangeFlag:
            filteredEligibilityFlag.length > 0 ? true : false,
        },
      };

      if (
        this.additionalQuestionsFlag &&
        this.generalEligibilityDetermination.changeImpediment
      ) {
        this.$refs.additionalQuestions.mapQuestionsAnswers();
        data.StudentExitAdditionalQuestions = this.$refs.additionalQuestions.PeiAdditionalQuestionsToDB;
      }

      if (
        this.backupDocumentsData != null &&
        this.backupDocumentsData.types.length > 0
      ) {
        this.backupDocumentsData.files.forEach((item, index) => {
          let file = {
            documentId: item.id,
            DocumentName: item.name,
            DocumentTypeId: this.backupDocumentsData.types[index]
              .documentTypeId,
          };
          data.elegibilityInfo.backupDocumentsData.push(file);
        });

        data.documentTypes = this.backupDocumentsData.types;
      }
      let formData = objectToFormData(data, { indices: true });

      this.currentEvaluationDocuments.forEach((element) => {
        if (!element.attachment) return;

        if (
          element.documentType.id == documentTypes.EvaluationDiscussionMinute
        ) {
          formData.append('minuteRequest', element.attachment);
        } else {
          formData.append('other', element.attachment);
        }
      });

      if (
        this.backupDocumentsData != null &&
        this.backupDocumentsData.types.length > 0
      ) {
        this.backupDocumentsData.files.map((file) => {
          formData.append(`documents`, file);
        });
      }

      return formData;
    },
    async getParticipationTypeList() {
      await this.$ApiGet('/api/pei/participationTypeList')
        .then((res) => {
          this.participationTypeList = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async getAlternateParticipationTypeList() {
      await this.$ApiGet('/api/pei/alternateParticipationTypeList')
        .then((res) => {
          this.alternateParticipationTypeList = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    //End Section IV
    //Section V
    async getImpedimentOptions() {
      await studentTrianualService.getImpediments().then((res) => {
        this.determinationElegibilityOptions.impediments = res.data;
      });
      await studentTrianualService.getImpedimentsMultiple().then((res) => {
        this.determinationElegibilityOptions.multipleImpediments = res.data;
      });
      await studentTrianualService.getSeverities().then((res) => {
        this.determinationElegibilityOptions.severities = res.data;
      });
      await studentTrianualService.getDisorders().then((res) => {
        this.determinationElegibilityOptions.disorders = res.data;
      });
    },
    async getConditionsCatalog() {
      await studentTrianualService
        .getEligibilityDeterminationConditions()
        .then((res) => {
          this.determinationElegibilityOptions.conditions = res.data;
        });
    },
    //Signature Managment methods
    addSignature() {
      this.signatureCounter -= 1;
      this.signatureList.push({
        id: this.signatureCounter,
        signature: {
          name: '',
          positionId: undefined,
          participationId: undefined,
          alternateId: undefined,
        },
        groupId: 0,
        isRequired: this.validateComponent,
        isRemovable: true,
        isDisabled: false,
      });
    },
    deleteSignature(id) {
      let signatureListIndex = this.signatureList.findIndex((e) => e.id === id);
      this.signatureList.splice(signatureListIndex, 1);
    },
    async setSignatureConfig() {
      //** Positions for Signatures */ */
      let self = this;
      await signatureService.getPositions().then((result) => {
        self.availableSignatureOptions = result.data;
      });

      //*****signature Management********
      this.signatureList = [];
      //getting default Signatures
      let signature1 = this.getBasicSignature(1);
      if (signature1 != undefined) {
        this.signatureList.push(signature1);
      }
      let signature5 = this.getBasicSignature(5);
      if (signature5 != undefined) {
        this.signatureList.push(signature5);
      }

      let signature6 = this.getBasicSignature(4);
      if (signature6 != undefined) {
        this.signatureList.push(signature6);
      }
    },
    addSpecialistSignature() {
      let existSpecialistRow = this.signatureList.find(
        (x) =>
          !x.isRemovable &&
          x.signature.positionId &&
          x.signature.positionId.signaturePositionId == 850
      );
      if (!existSpecialistRow) {
        this.signatureCounter -= 1;
        this.signatureList.push({
          id: this.signatureCounter,
          signature: {
            name: '',
            positionId: { signaturePositionId: 850 },
            participationId: undefined,
            alternateId: undefined,
          },
          groupId: 13,
          isRequired: this.validateComponent,
          isRemovable: false,
          isDisabled: false, //Search PositionId for specialist
          positionDisabled: true,
        });
      }
    },
    removeSpecialistSignature() {
      //this.signatureList.push(specialistSignature);
      let existSpecialistRow = this.signatureList.find(
        (x) =>
          !x.isRemovable &&
          x.signature.positionId &&
          x.signature.positionId.signaturePositionId == 850
      );
      if (existSpecialistRow) {
        this.deleteSignature(existSpecialistRow.id);
      }
    },
    //End Signatures Methods
    onEligibilityDataChanged(data) {
      this.additionalQuestionsFlag =
        this.generalEligibilityDetermination.academicYearId != null &&
        this.eligibilityDeterminationDataTriannual != null &&
        this.eligibilityDeterminationDataTriannual.eligibilityFlag == '0';
    },
    getSignatureList() {
      const signatures = [];
      const participantSignatures = this.signatureList;

      participantSignatures.forEach((x) => {
        let signInfo = {
          id: x.id,
          fullName: x.signature.name,
          positionId: x.signature.positionId?.signaturePositionId,
          participationType: x.signature.participationId?.id,
          alternateParticipationType: x.signature.alternateId
            ? x.signature.alternateId.id
            : undefined,
          IsRequired: !x.isRemovable,
        };
        signatures.push(signInfo);
      });

      return signatures;
    },
    getBasicSignature(groupId) {
      let signature;
      if (this.elegibilityInfo != null) {
        signature = this.elegibilityInfo.attendanceInfo.find((x) =>
          this.availableSignatureOptions.some(
            (y) =>
              y.signatureGroupId == groupId &&
              y.signaturePositionId == x.positionId
          )
        );
      }

      if (signature != undefined) {
        return {
          id: signature.id,
          signature: {
            name: signature.fullName,
            positionId: { signaturePositionId: signature.positionId },
            participationId: { id: signature.participationTypeId },
            alternateId: { id: signature.alternateParticipationTypeId },
          },
          groupId: groupId,
          isRequired: this.validateComponent,
          isRemovable: false,
          isDisabled: false,
        };
      } else {
        this.signatureCounter -= 1;
        return {
          id: this.signatureCounter,
          signature: {
            name: '',
            positionId: undefined,
            participationId: undefined,
            alternateId: undefined,
          },
          groupId: groupId,
          isRequired: this.validateComponent,
          isRemovable: false,
        };
      }
    },
    getObserver(id, observer) {
      this.observers = {
        ...this.observers,
        [id]: observer,
      };
    },
    onGetEvaluationsHandler(evaluations) {
      this.currentEvaluations = [...evaluations];
    },
    onAddEvaluationDocument(model) {
      this.currentDocuments.push(model);
    },
    onRemoveEvaluationDocument(dto) {
      const filtered = this.currentDocuments.filter(
        (x) => x.documentType.id != dto.documentType.id
      );

      this.currentDocuments = [...filtered];
    },
    onEditEvaluationDocument(dto) {
      let evaluationItem = this.currentDocuments.find((x) => x.id == dto.id);

      evaluationItem.attachment = dto.attachment;
      evaluationItem.documentName = dto.documentName;
      evaluationItem.documentType = dto.documentType;
      evaluationItem.evaluations = [...dto.evaluations];

      evaluationItem.fileId = dto.fileId;
      evaluationItem.compuMinuteId = dto.compuMinuteId;
      evaluationItem.useSystemMinute = dto.useSystemMinute;
      evaluationItem.meetingDate = dto.meetingDate;
    },
    validateRejectedEvaluations() {
      const isValid = this.evaluationsWithoutDocuments.length == 0;
      return isValid;
    },
    validateNonRecommendedEvaluations() {
      const isValid = this.nonRecommendedWithoutDocuments.length == 0;
      return isValid;
    },
    async persistCurrentInformation(evaluations) {
      const persistDto = {
        studentSieid: this.student.studentId,
        elegibilityInfo: {},
        placementCommittee: {},
        evaluations: [],
        showElegibilityDetermination: this.showElegibilityDetermination,
      };

      if (this.showElegibilityDetermination) {
        const refTriannualEvaluation = this.$refs.triannualEvaluation;

        persistDto.triannualEvaluation = { ...refTriannualEvaluation.field };
      }

      if (this.generalEligibilityDetermination.academicYearId) {
        persistDto.academicYearId = this.generalEligibilityDetermination.academicYearId;
      }

      if (this.generalEligibilityDetermination.academicYearDesc) {
        persistDto.academicYearDesc = this.generalEligibilityDetermination.academicYearDesc;
      }

      if (this.generalEligibilityDetermination.academicyearfordate) {
        persistDto.evaluationDate = this.generalEligibilityDetermination.academicyearfordate;
      }

      if (this.evaluationDateTypeCode) {
        persistDto.evaluationDateTypeCode = this.evaluationDateTypeCode;
      }

      if (this.evaluationDescription) {
        persistDto.commentDescription = this.evaluationDescription;
      }

      if (this.generalEligibilityDetermination.changeImpediment) {
        persistDto.impedimentChangeFlag = this.generalEligibilityDetermination.changeImpediment;
      }

      let filteredEligibilityFlag = this.evaluationInformationLayout
        ? this.evaluationInformationLayout.evaluationInformationData.filter(
            (x) => x.elegibilityFlag == '1'
          )
        : '';

      persistDto.isSufficientFlag =
        filteredEligibilityFlag.length > 0 ? '1' : '0';
      persistDto.hasEligibilityFlag =
        filteredEligibilityFlag.length > 0 ? true : false;

      persistDto.elegibilityInfo = {
        ...this.eligibilityDeterminationDataTriannual,
      };

      if (
        this.evaluationInformationLayout &&
        this.evaluationInformationLayout.evaluationInformationData
      ) {
        persistDto.elegibilityInfo.eligibilityEvaluationInfo = this.evaluationInformationLayout.evaluationInformationData;
      }

      if (this.signatureList.length > 0)
        persistDto.elegibilityInfo.attendanceInfo = [...this.signatureList];

      if (this.currentDocuments) {
        const documents = await this.getDocumentsForPersist();
        persistDto.elegibilityInfo.documentAttachmentInfo = documents;
      }

      if (this.generalEligibilityDetermination.academicyearfordate) {
        persistDto.placementCommittee.committeeDate = this.generalEligibilityDetermination.academicyearfordate;
      }

      if (this.generalEligibilityDetermination.academicYearId) {
        persistDto.placementCommittee.academicYearId = this.generalEligibilityDetermination.academicYearId;
      }

      if (this.evaluationDescription) {
        persistDto.committeeDescription = this.evaluationDescription;
      }

      if (this.placementCommitteeCategoryId) {
        persistDto.placementCommitteeCategoryId = this.placementCommitteeCategoryId;
      }

      persistDto.impedimentChangeFlag =
        filteredEligibilityFlag.length > 0 ? true : false;

      if (
        this.additionalQuestionsFlag &&
        this.generalEligibilityDetermination.changeImpediment
      ) {
        this.$refs.additionalQuestions.mapQuestionsAnswers();
        persistDto.StudentExitAdditionalQuestions = this.$refs.additionalQuestions.PeiAdditionalQuestionsToDB;
      }

      // Evaluations
      persistDto.evaluations = [...evaluations];

      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(persistDto));
    },
    async getDocumentsForPersist() {
      const currentDocs = [];

      if (this.currentDocuments.length > 0) {
        for (let index = 0; index < this.currentDocuments.length; index++) {
          const doc = this.currentDocuments[index];

          const item = {
            documentName: doc.documentName,
            documentType: doc.documentType,
            evaluations: [...doc.evaluations],
            compuMinuteId: doc.compuMinuteId,
            attachment: await this.toBase64(doc.attachment),
            meetingDate: doc.meetingDate,
          };

          currentDocs.push(item);
        }
      }

      return currentDocs;
    },
    async setPersistedDocuments(documents) {
      if (documents.length > 0) {
        for (let index = 0; index < documents.length; index++) {
          const doc = documents[index];

          const item = {
            documentName: doc.documentName,
            documentType: doc.documentType,
            evaluations: [...doc.evaluations],
            attachment: await this.fromBase64ToFile(
              doc.attachment,
              doc.documentName
            ),
          };

          this.currentDocuments.push(item);
        }
      }
    },
    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async fromBase64ToFile(base64File, filename) {
      const response = await fetch(base64File);
      const blob = await response.blob();
      return new File([blob], filename, { type: 'application/pdf' });
    },
    async setPersistedInformation() {
      const persistDto = localStorage.getItem(LOCAL_STORAGE_KEY);

      if (persistDto) {
        const model = JSON.parse(persistDto);

        this.showElegibilityDetermination = model.showElegibilityDetermination;

        if (this.showElegibilityDetermination) {
          await this.$nextTick(async () => {
            this.eligibilityDeterminationDataTriannual = model.elegibilityInfo;

            this.determinationElegibilityOptions.conditions = this.determinationElegibilityOptions.conditions.filter(
              (x) =>
                !model.elegibilityInfo.eligibilityDeterminationConditions.selectedItems
                  .map((p) => p.id)
                  .includes(x.id)
            );

            this.$refs.triannualEvaluation.impedimentsOptions =
              model.elegibilityInfo.impedimentsOptions;
          });
        }

        if (model.academicYearId) {
          this.$refs.generalInfo.value.academicYearId = model.academicYearId;
        }

        if (model.academicYearDesc) {
          this.$refs.generalInfo.value.academicYearDesc =
            model.academicYearDesc;
        }

        if (model.evaluationDate) {
          this.$refs.generalInfo.value.academicyearfordate =
            model.evaluationDate;
          await this.$refs.generalInfo.onSelectedDate(model.evaluationDate);
        }

        if (model.evaluationDateTypeCode) {
          this.evaluationDateTypeCode = model.evaluationDateTypeCode;
        }

        if (model.commentDescription) {
          this.$refs.generalInfo.value.comment = model.commentDescription;
          this.evaluationDescription = model.commentDescription;
        }

        if (model.impedimentChangeFlag) {
          this.generalEligibilityDetermination.changeImpediment =
            model.impedimentChangeFlag;
        }

        this.eligibilityDeterminationDataTriannual = {
          ...model.elegibilityInfo,
        };

        if (
          model.elegibilityInfo &&
          model.elegibilityInfo.eligibilityEvaluationInfo
        ) {
          this.evaluationInformationLayout.evaluationInformationData =
            model.elegibilityInfo.eligibilityEvaluationInfo;
        }

        if (model.elegibilityInfo.attendanceInfo.length > 0) {
          const signatures = [...model.elegibilityInfo.attendanceInfo];

          this.signatureList = [...signatures];
        }

        if (model.elegibilityInfo.documentAttachmentInfo.length > 0) {
          const documents = [...model.elegibilityInfo.documentAttachmentInfo];
          await this.setPersistedDocuments(documents);
        }

        let filteredEligibilityFlag = this.evaluationInformationLayout
          ? this.evaluationInformationLayout.evaluationInformationData.filter(
              (x) => x.elegibilityFlag == '1'
            )
          : '';

        if (model.placementCommittee.committeeDate) {
          this.generalEligibilityDetermination.academicyearfordate =
            model.placementCommittee.committeeDate;
        }

        if (model.placementCommittee.academicYearId) {
          this.generalEligibilityDetermination.academicYearId =
            model.placementCommittee.academicYearId;
        }

        if (model.committeeDescription) {
          this.evaluationDescription = model.committeeDescription;
        }

        if (model.placementCommitteeCategoryId) {
          this.placementCommitteeCategoryId =
            model.placementCommitteeCategoryId;
        }

        model.impedimentChangeFlag =
          filteredEligibilityFlag.length > 0 ? true : false;

        if (
          model.StudentExitAdditionalQuestions &&
          model.impedimentChangeFlag
        ) {
          this.$refs.additionalQuestions.mapQuestionsAnswers();
          this.$refs.additionalQuestions.PeiAdditionalQuestionsToDB =
            model.StudentExitAdditionalQuestions;
        }

        // Evaluations
        this.$refs.evaluationInfo.evaluationInformationLayout.evaluationInformationData = [
          ...model.evaluations,
        ];

        model.evaluations.forEach((e) => {
          const refEvaluationInformationRow = this.$refs.evaluationInfo.$refs[
            `evaluation-information-row-${e.studentEvaluationId}`
          ];

          const refEvaluationRecommendRow = this.$refs.evaluationInfo.$refs[
            `evaluation-recommend-row-${e.studentEvaluationId}`
          ];

          const selectedDiscussionStatus = this.collections.discussionStatuses.find(
            (s) => s.id == e.discussionStatusId
          );

          if (refEvaluationInformationRow) {
            if (selectedDiscussionStatus)
              refEvaluationInformationRow[0].model.discussionStatus = selectedDiscussionStatus;

            refEvaluationInformationRow[0].model.determines = e.determines;

            if (e.determines)
              refEvaluationInformationRow[0].yesNoOptions[0].check = true;
            else if (e.determines == false)
              refEvaluationInformationRow[0].yesNoOptions[1].check = true;

            if (e.rejectionReasons && e.rejectionReasons.length > 0) {
              refEvaluationInformationRow[0].rejectionPanelShow = true;

              e.rejectionReasons.forEach((r) => {
                const reason = {
                  id: r.id,
                  name: r.name,
                  comment: r.comment,
                };

                refEvaluationInformationRow[0].model.rejectionSelectedReasons.push(
                  reason
                );

                const filteredReasonsList = this.$refs.evaluationInfo.rejectionReasons.filter(
                  (x) => x.id !== r.id
                );

                this.$refs.evaluationInfo.rejectionReasons = [
                  ...filteredReasonsList,
                ];
              });
            }
          } else if (refEvaluationRecommendRow) {
            if (selectedDiscussionStatus)
              refEvaluationRecommendRow[0].model.discussionStatus = selectedDiscussionStatus;

            if (e.recommended)
              refEvaluationRecommendRow[0].questions[0].radioOptions[0].check = true;
            else if (e.recommended == false)
              refEvaluationRecommendRow[0].questions[0].radioOptions[1].check = true;

            refEvaluationRecommendRow[0].recommendedPanelShow = e.recommended;
            refEvaluationRecommendRow[0].model.recommended = e.recommended;
            refEvaluationRecommendRow[0].model.recomendationComment =
              e.referralRequestReason;
          }

          this.evaluationInformationLayout.evaluationInformationData = [
            ...model.evaluations,
          ];
        });

        localStorage.removeItem(LOCAL_STORAGE_KEY);
      }
    },
    async loadDiscussionStatuses() {
      const { data } = await getEvaluationDiscussionStatus();
      this.collections.discussionStatuses = [...data];
    },
    async setReadOnlyData(evaluations) {
      evaluations.forEach((evaluation) => {
        this.$refs.generalInfo.value = {
          ...this.$refs.generalInfo.value,
          academicyearfordate: evaluation.evaluationDate,
          academicYearDesc: evaluation.academicYearDesc,
          comment: evaluation.evaluationComment,
        };
        this.generalEligibilityDetermination = {
          ...this.generalEligibilityDetermination,
          academicyearfordate: evaluation.evaluationDate,
        };
        const discussionModel = this.$refs.evaluationInfo.$data
          .evaluationInformationLayout;

        discussionModel.evaluationInformationData = evaluations.map((x) => ({
          ...x,
          validForDiscussion: x.recommended == null,
          validForRecommendation: x.recommended != null,
          statusName: x.evaluationStatus,
          // statusName and discussionStatusDescription is the same, but in recommended-row component they changed the name.
          discussionStatusDescription: x.evaluationStatus,
          studentEvaluationId: x.evaluation.studentEvaluationId,
          rejectionReasons: [],
        }));
        // fill the evaluation discussion or recommended section
        this.$nextTick(() => {
          const row = this.$refs.evaluationInfo.$refs[
            `evaluation-information-row-${evaluation.evaluation.studentEvaluationId}`
          ];
          if (row?.length) {
            row[0].model.discussionStatus = {
              id: evaluation.discussionStatusId,
              name: evaluation.discussionStatusName,
            };
            // instead of setting the  row[0].model.determines = true or false, we prefer to use its change method
            // which emit the changes to show the determination information's section
            row[0].onChangeYesNo({ value: evaluation.isDetermination });
            const yesOrNoOption = row[0].yesNoOptions.find(
              (x) => x.value === evaluation.isDetermination
            );
            // marks the option in the component either Yes or Not.
            if (yesOrNoOption && !yesOrNoOption.check)
              yesOrNoOption.check = true;

            // set rejection reason comments for evaluation in status : Accepted-Partially or Rejected
            if (evaluation.rejectionComments?.length) {
              row[0].model.rejectionSelectedReasons = evaluation.rejectionComments.map(
                (x, index) => ({
                  comment: x.comment,
                  name: x.name,
                  id: index,
                })
              );
            }
          }
          // if evaluation is mark as YES in determination field named (¿Determina?) then fill the triannual section
          if (evaluation.isDetermination)
            this.fillTriannualSectionForReadOnly(evaluation);
        });

        if (evaluation.evaluationDocuments?.length) {
          this.currentDocuments = evaluation.evaluationDocuments.map((x) => {
            const evaluations = x.evaluations.map((e, index) => ({
              id: index,
              disciplineTypeName: e.evaluationName,
              evaluationDate: e.evaluationDate,
            }));

            const result = {
              ...x,
              documentName: x.fileName,
              documentType: {
                id: 0,
                name: x.documentTypeName,
              },
              evaluations: evaluations,
            };
            return result;
          });
        }
      });

      // set the signatures
      // it's in setTimeout because one of the methods above appends a signature depending on the impediment set.
      // and the append finishes happening after its execution
      setTimeout(() => {
        this.signatureList = evaluations[0].placementCommitteeAttendances.map(
          (x, index) => ({
            id: index + 1,
            signature: {
              name: x.attendedFullName,
              positionId: this.availableSignatureOptions.find(
                (position) => position.signaturePositionId === x.position?.id
              ),
              participationId: x.participationType,
              alternateId: x.alternateParticipationType,
            },
            groupId: 0,
            isRequired: this.validateComponent,
            isRemovable: true,
            isDisabled: false,
          })
        );
      }, 500);
    },
    fillTriannualSectionForReadOnly(evaluation) {
      if (
        evaluation.elegibilityInfo &&
        evaluation.elegibilityInfo.impedimentEvaluationComments &&
        evaluation.elegibilityInfo.impedimentEvaluationComments.length
      ) {
        const elegibilityInfo = evaluation.elegibilityInfo;
        const triannualRef = this.$refs.triannualEvaluation;
        const triannualFields = triannualRef.field;

        triannualRef.radioElegibilityChange(
          evaluation.elegibilityDeterminationFlag
        );
        triannualFields.comments = elegibilityInfo.impedimentEvaluationComments;

        if (elegibilityInfo.postEligibilityMeetingsQty > 0) {
          triannualFields.meetingQty = {
            id: elegibilityInfo.postEligibilityMeetingsQty,
            name: elegibilityInfo.postEligibilityMeetingsQty,
          };
        }
        const isHealthSpecialistNecessary =
          elegibilityInfo.healthSpecialistParticipatedFlag === '1';
        triannualFields.radioHealthSpecialistNecessary = isHealthSpecialistNecessary;
        if (isHealthSpecialistNecessary) {
          triannualFields.radioParticipatedSpecialist.visible = true;
          triannualFields.radioParticipatedSpecialist =
            elegibilityInfo.healthSpecialistParticipationFlag === '1';
        }
        //cert checkbox
        triannualFields.certification = true;

        // impediment field and its dynamic fields
        if (elegibilityInfo.studentDisability?.id) {
          triannualFields.impediment = elegibilityInfo.studentDisability;
          // here it validates the Disability NAME, not the ID but the NAME. If the name changes in DB then this form and the old won't work anymore.
          triannualRef.cleanImpedimentDependency();
          triannualFields.disorders = elegibilityInfo.impediment;
          triannualFields.severity = elegibilityInfo.severity;
          if (elegibilityInfo.impedimentPartialHearingFlag?.length)
            triannualFields.partialHearing =
              elegibilityInfo.impedimentPartialHearingFlag == '1';
          // if it's multi impediments
          if (
            elegibilityInfo.studentDisability.id ===
            impedimentTypeNames.multipleImpediments
          ) {
            triannualRef.showImpedimentMultipleSelected = true;
            // set multiple impediments
            if (elegibilityInfo.multipleImpediments?.length) {
              triannualFields.dropDownImpedimentMultiple.selectedItems = elegibilityInfo.multipleImpediments.map(
                (x) => ({
                  id: x.impedimentId,
                  association: x.severityId,
                  association: x.severityId,
                  association: x.partialHearingFlag,
                  title: x.disabilityName,
                  name: x.partialHearingFlag?.length
                    ? x.partialHearingFlag === '1'
                      ? '- Sordo parcial: SÍ ' + x.impedimentName
                      : '- Sordo parcial: NO ' + x.impedimentName
                    : x.impedimentName.length
                    ? '-' + x.impedimentName
                    : '',
                })
              );
              triannualRef.getData();
              triannualRef.showImpedimentMultipleSection = true;
              triannualRef.showImpedimentMultipleSelected = true;
            }
          }
        }
      }
    },
    isAnyEvaluationDetermining() {
      const evaluations =
        this.$refs?.evaluationInfo?.evaluationList?.filter(
          (x) => x.validForDiscussion
        ) ?? [];
      return evaluations.some((x) => x.determines);
    },
    getSelectedEvaluations() {
      return this.$refs.evaluationInfo?.selectedEvaluations;
    },
    getRejectedEvaluations() {
      const selectedEvaluations = this.getSelectedEvaluations();

      return this.currentEvaluations.filter(
        (x) =>
          x.discussionStatusId == DiscussionStatus.Rejected &&
          selectedEvaluations.some((s) => s.id === x.studentEvaluationId)
      );
    },
    refreshEvaluationsWithoutDocuments() {
      const withoutDocument = [];
      const selectedEvaluations = this.getSelectedEvaluations();

      if (!selectedEvaluations?.length > 0) {
        this.eveluationsWithoutDocuments = [];
        return withoutDocument;
      }

      const rejectedEvaluations = this.getRejectedEvaluations();
      if (rejectedEvaluations.length > 0) {
        const evaluationDocument = this.currentDocuments.find(
          (x) => x.documentType.id == DOCUMENT_TYPES.MINUTA
        );
        if (evaluationDocument) {
          const { evaluations } = evaluationDocument;

          rejectedEvaluations.forEach((x) => {
            const exists = evaluations.find(
              (e) => e.id == x.studentEvaluationId
            );
            if (!exists) {
              withoutDocument.push(
                `${x.evaluationDate} - ${x.disciplineTypeName}`
              );
            }
          });
        } else {
          rejectedEvaluations.forEach((x) => {
            withoutDocument.push(
              `${x.evaluationDate} - ${x.disciplineTypeName}`
            );
          });
        }
      }

      this.evaluationsWithoutDocuments = withoutDocument;
    },
    async printSaee05() {
      try {
        if (this.evaluationDateId > 0) {
          const { data } = await this.$ApiGet(
            `/api/studentevaluation/${this.student.studentId}/EligibilityDeterminationForm/${this.evaluationDateId}`
          );
          generalService.documentDownloadReport(data.content, data.filename);
        } else {
          this.ShowToast(
            'Alerta',
            'reporte no puede ser descargado.',
            'warning'
          );
          return;
        }
      } catch (err) {
        this.ShowToast('Alerta', 'Error al descargar el reporte.', 'error');
      }
    },
    async printSaee03() {
      try {
        // if has any Non determines evaluation then print SAEE-03c report.
        if (this.hasNonDeterminesEvaluation) {
          const studentEvaluationIds = this.getEvaluations
            .filter(
              (x) =>
                x?.determines === false ||
                x?.discussionStatusId == DiscussionStatus.Rejected
            )
            .map((x) => x.studentEvaluationId);
          await reportService.downloadMultipleSaee03cReports(
            studentEvaluationIds
          );
        } else {
          this.ShowToast(
            'Alerta',
            'reporte no puede ser descargado.',
            'warning'
          );
          return;
        }
      } catch (err) {
        this.ShowToast('Alerta', 'Error al descargar el reporte.', 'error');
      }
    },
  },
  async created() {
    await this.getStudent(this.studentSie);
  },
};
</script>
<style scoped>
.tag-badge {
  display: inline-block;
  padding-right: 1em;
  height: 42px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
  margin-bottom: 10px;
}

.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}

.border-box {
  border: 1px solid #e2e2e2;
  border-radius: 5px 5px 0px 0px;
  padding: 20px;
  width: 100%;
}
.border-box.gray {
  border-radius: 0px 0px 5px 0px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-top: none;
  padding: 20px 0;
}
.border-box.gray.error {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #c9545e;
}
.invalid {
  text-align: left;
  font: Lato, Regular;
  letter-spacing: 0;
  color: #ff5b5c;
  margin-bottom: 5px;
  font-weight: normal;
}
i.far.fa-check-circle {
  font-size: 24px;
  padding-right: 4px;
  line-height: 18px;
  margin-left: 4px;
}
</style>
